import type { ExtensionConfig } from '@goto/shell'
import { getOOSArtifactUrl } from '../helpers/experience-helpers'
import { getLaunchDarklyFlag } from '../helpers/shell-helpers'
import { LaunchDarklyVariations } from '../models/feature-flag.models'

const extensionConfig: ExtensionConfig = {
  id: '@goto/oos-webinar-app',
  get url() {
    const version = getLaunchDarklyFlag(LaunchDarklyVariations.OOS_WEBINAR_VERSION)
    return new URL(getOOSArtifactUrl('webinar-extension', version))
  },
  prerequisites: {
    roles: 'g2w',
    accountSettings: 'webinar.isWebinarGoToAppEnabled',
  },
}

export default extensionConfig
